// Temporarily hide the backoffice notifications section.
export const SHOW_NOTIFICATIONS = false

export const CourseType = {
    Masterclass: "masterclass",
    Professional: "professional",
    Bootcamp: "bootcamp",
    Webinar: "webinar",
    Pack: "pack"
}

export const CourseStatus = {
    ToStart: "to_start",
    InProgress: "in_progress",
    Ended: "ended"
}

export const LessonStatus = {
    ToStart: "to_start",
    Live: "live",
    Ended: "ended",
    All: ["live", "to_start", "ended"]
}

export const TagType = {
    General: "general",
    Feature: "feature"
}

export const ArticleCardType = {
    Large: "large",
    Medium: "medium",
    Small: "small"
}

export const FeedType = {
    Lesson: "lesson",
    Exercise: "exercise",
    Material: "material",
    Communication: "communication"
}

export const palette = [
  // 🌊 Blu & Azzurri
  '#89C5E9', // azzurro ceruleo
  '#93CADB', // azzurro pastello originale
  '#A5BCE0', // blu polvere
  '#95A8C8', // blu acciaio

  // 💜 Viola & Lilla
  '#CAABD4', // lilla chiaro
  '#B7A8E3', // lavanda fredda
  '#C7B8E0', // pervinca
  '#D6A7CC', // malva
  '#c98bcfff', // viola pastello originale

  // 🌿 Verdi & Turchesi
  '#2fc6a0', // verde acqua
  '#AEE6B6', // verde menta
  '#99D3A6', // verde giada
  '#B9CBB5', // verde salvia
  '#ABC760', // verde lime tenue
  '#A7B7A3', // grigio-verde neutro

  // 🌞 Gialli & Aranciati
  '#FFD600', // giallo vivo
  '#E8D479', // senape tenue
  '#EBAE87', // terracotta
  '#FFB67F', // arancio bruciato
  '#FFC9A9', // albicocca chiaro

  // ❤️ Rossi & Rosati
  '#FF9A8C', // rosa corallo
  '#FFA78A', // corallo tenue
  '#F59B9B', // rosso carminio chiaro

  // 🤎 Neutri & Grigi
  '#C8B6A6', // cacao chiaro
  '#D6D2C4', // grigio sabbia
  '#B0B6BC', // grigio ardesia
]

function darkenColor(hex, amount = 0.3) {
  const num = parseInt(hex.slice(1), 16);
  const r = Math.round(((num >> 16) & 0xff) * (1 - amount));
  const g = Math.round(((num >> 8) & 0xff) * (1 - amount));
  const b = Math.round((num & 0xff) * (1 - amount));
  const darkened = (1 << 24) | (r << 16) | (g << 8) | b;
  return `#${darkened.toString(16).slice(1)}`;
}

export const darkPalette = palette.map(color => darkenColor(color, 0.4));

export const Stripe = {
    publicKey: 'pk_test_51OkqgmHGtSMxXXMSjWJSEeMgIsM2adVltIURTRJcNYUvJfGKr262V0qCTx1aMu29EMDQ7qkHdXVkwW1Y2Vv5Jy8b00q4ZoPPYN'
}

export const PaymentStatus = {
    Succeeded: 'succeeded',
    Failed: 'failed',
    Pending: 'pending',
    Refunded: 'refunded',
    Processing: 'processing',
    PartiallyPaid: 'partially_paid',
    PartiallyRefunded: 'partially_refunded',
    RefundedFailed: 'refund_failed',
    WaitingForRefund: 'waiting_for_refund',
    Upaid: 'unpaid',
}

export const OrderStatus = {
    Pending: "pending",
    Processing: "processing",
    Succeeded: "succeeded",
    Failed: "failed",
    Refunded: "refunded",
    WaitingForRefund: "waiting_for_refund",
    PartiallyRefunded: "partially_refunded",
    RefundFailed: "refund_failed",
    PartiallyPaid: "partially_paid",
    RequiresAction: "requires_action",
    Unpaid: "unpaid",
    Abandoned: "abandoned",
    Canceled: "cancelled"
}


export const NotificationType = {
    LessonLive: 'lesson_live',
    LessonEdit: 'lesson_edit',
    ExerciseReminder: 'exercise_reminder',
    ExerciseResult: 'exercise_result',
    ExerciseExpired: 'exercise_expired',
    MaterialUpload: 'material_upload',
    CourseCompleted: 'course_completed',
    Announcement: 'announcement'
}

export const RowType = {
    Text: "text",
    Image: "image",
    Video: "video",
    Columns: "columns"
}

export const ButtonStatus = {
    Loading: "loading",
    Success: "success",
    Error: "error"
}

export const AccountStatus = {
    Active: "active",
    Suspended: "suspended"
}

export const ProfileType = {
    User: "user",
    Teacher: "teacher",
    Admin: "admin"
}

export const CompanyType = {
    B2BTeaching: "b2b_teaching",
    LeadGenerationProvider: "lead_generation_provider",
    TrainingBuyer: "training_buyer",
    EventPartner: "event_partner",
    Other: "other",
}

export const CompanyStatus = {
    Active: "active",
    Inactive: "inactive",
}

export const CompanyAdminRole = {
    Owner: "owner",
    Admin: "admin",
    Manager: "manager",
    Analyst: "analyst",
    Sales: "sales",
}

export const Role = {
    Teacher: "teacher",
    Tutor: "tutor"
}

export const UserPages = {
    Students: "students",
    Teachers: "teachers",
    Tutors: "tutors",
    Admins: "admins",
    Companies: "companies",
}

export const AdminRole = {
    Main: "main",
    Sales: "sales",
    Media: "media",
    Nabila: "nabila",
    Marketing: "marketing",
    EventManager: "event_manager",
}

export const MailStatus = {
    Scheduled: "scheduled",
    Sent: "sent",
    Failed: "failed",
    Cancelled: "cancelled",
    Draft: "draft",
}

export const MailingType = {
    ApplicationSent: "application_sent",
    ApplicationApproved: "application_approved",
    ApplicationRejected: "application_rejected",
    InfoRequired: "info_required",
    InfoApproved: "info_approved",
    Welcome: "welcome",
    WelcomeTeacher: "welcome_teacher",
    WelcomeAdmin: "welcome_admin",
    ResetPassword: "reset_password",
    VerifyEmail: "verify_email",
    OrderConfirmation: "order_confirmation",
    AdminOrderConfirmation: "admin_order_confirmation",
    GiftCourse: "gift_course",
    VoucherActivation: "voucher_activation",
    CertificateRequest: "certificate_request",
    CourseSubscription: "course_subscription",
    NewEdition: "new_edition",
    UpcomingEdition: "upcoming_edition",
    EndedEdition: "ended_edition",
    InstallmentsExpiring: "installments_expiring",
    InstallmentsExpired: "installments_expired",
    InstallmentPaid: "installment_paid",
    InvoiceFulfilled: "invoice_fulfilled",
    InstallmentPaymentLink: "installment_payment_link",
    PendingOrderCheckout: "pending_order_checkout",
    SalesPhoneCorrection: "sales_phone_correction",
    SalesPaymentLink: "sales_payment_link",
    EditionCustom: "edition_custom",
    EventTicket: "event_ticket",
    EventActivity: "event_activity",
    EventPressTicket: "event_press_ticket",
    CompanyInvite: "company_invite",
}

export const PermissionLevel = {
    All: Object.values(AdminRole),
    Administration: [AdminRole.Main],
    Sales: [AdminRole.Main, AdminRole.Sales],
    Media: [AdminRole.Main, AdminRole.Media],
    Nabila: [AdminRole.Main, AdminRole.Nabila],
    Marketing: [AdminRole.Marketing, AdminRole.Main]
}

export const BookingStatus = {
    Pending: "pending",
    Confirmed: "confirmed",
    Completed: "completed"
}

export const BookingMethod = {
    Phone: "phone",
    Email: "email",
    Whatsapp: "whatsapp"
}

export const TimeGroup = {
    Daily: "daily",
    Monthly: "monthly"
}

export const TimeFilter = {
    Today: "today",
    CurrentMonth: "month",
    Last7Days: "last_7_days",
    Last30Days: "last_30_days",
    Next7Days: "next_7_days",
    Next30Days: "next_30_days"
}

export const LessonType = {
    Live: "live",
    Recorded: "recorded"
}

export const FileType = {
    Image: "image",
    Video: "video",
    All: "all"
}

export const SortDirection = {
    Ascending: "",
    Descending: "-"
}

export const SurveyType = {
    SingleChoice: "SingleChoice",
    MultipleChoice: "MultipleChoice",
    Open: "Open",
    Numeric: "Numeric",
}


export const MacroBackgrounds = {
    Background1: `<?xml version="1.0" encoding="UTF-8"?>
<!-- Generated by Pixelmator Pro 3.6.14 -->
<svg width="1049" height="590" viewBox="0 0 1049 590" xmlns="http://www.w3.org/2000/svg">
    <path id="Shape" fill=%secondary% stroke="none" d="M 616.013794 0 C 656.533691 45.966064 727.547913 95.402527 850.751465 137.174988 C 1166.075928 244.086548 919.436035 533.950012 707.138367 545.75 C 584.422302 552.571106 473.884125 529.688965 373.095764 508.825043 C 231.798523 479.5755 109.663338 454.292603 0 520.379089 L 0 590 C 22.57242 590.08905 22.364441 590 49.952381 590 L 999.047607 590 C 1026.635498 590 1026.536865 589.860413 1049 590 L 1049 0 C 1026.631226 0.023315 1026.635498 0 999.047607 0 L 616.013794 0 Z"/>
    <path id="Back" fill=%primary% fill-opacity="0.1" stroke="none" d="M 49.952381 0 L 999.047607 0 C 1026.635498 0 1026.638916 0.002258 1049 0 L 1049 590 C 1026.645142 589.988159 1026.635498 590 999.047607 590 L 49.952381 590 C 22.364441 590 22.351646 589.982483 0 590 L 0 0 C 22.407852 -0.035095 22.364441 0 49.952381 0 Z"/>
</svg>
`,
    Background2: `<?xml version="1.0" encoding="UTF-8"?>
<!-- Generated by Pixelmator Pro 3.6.14 -->
<svg width="1049" height="590" viewBox="0 0 1049 590" xmlns="http://www.w3.org/2000/svg">
    <path id="Percorso" fill=%secondary% stroke="none" d="M 824 0 C 812.200867 20.598389 802.171997 46.089966 795.222412 76.039246 C 763.149658 214.257294 818.873474 254.442535 877.141174 296.462219 C 931.890076 335.944275 988.884888 377.045959 977.404541 502.611816 C 974.427124 535.176819 966.984314 564.281738 955.842834 590 L 1002.584167 590 C 1027.942749 590 1049 590 1049 590 L 1049 0 C 1028.001099 0.422119 1028.358643 0 1003 0 L 824 0 Z"/>
    <path id="Rettangolo" fill=%primary% fill-opacity="0.1" fill-rule="evenodd" stroke="none" d="M 0 590 L 1048 590 L 1048 0 L 0 0 Z"/>
</svg>
`,
    Background3: `<?xml version="1.0" encoding="UTF-8"?>
<!-- Generated by Pixelmator Pro 3.6.14 -->
<svg width="1049" height="590" viewBox="0 0 1049 590" xmlns="http://www.w3.org/2000/svg">
    <path id="Percorso" fill=%secondary% stroke="none" d="M 1049 460.799103 C 941.023621 425.630219 731.196594 390.617584 576.167175 493.561554 C 361.670135 635.993713 37.576118 595.934692 12.525373 336.292725 C 0.38999 210.513733 60.636932 169.342255 118.509796 129.793182 C 163.94249 98.745453 207.912079 68.697571 214.250137 -0.5 L 48.53582 -0.5 C 21.730228 -0.5 0 -25.401611 0 0 L 0 590 C 0 615.401611 21.730228 590 48.53582 590 L 1049 590 C 1075.805664 590 1049 569.407898 1049 544.006287 L 1049 460.799103 Z"/>
    <path id="Rettangolo" fill=%primary% fill-opacity="0.1" fill-rule="evenodd" stroke="none" d="M 0 590 L 1049 590 L 1049 -2 L 0 -2 Z"/>
</svg>


`,
    Background4: `<?xml version="1.0" encoding="UTF-8"?>
<!-- Generated by Pixelmator Pro 3.6.14 -->
<svg width="1049" height="590" viewBox="0 0 1049 590" xmlns="http://www.w3.org/2000/svg">
    <path id="Percorso" fill=%secondary% stroke="none" d="M 1049 196.308929 C 917.309265 224.483612 719.629089 238.619202 585.561218 149.669647 C 371.064178 7.357971 46.97015 47.38324 21.919403 306.805939 C 9.784026 432.478241 70.030907 473.614777 127.903748 513.130371 C 159.532181 534.726196 190.451553 555.837952 208.459106 590 L 48.53582 590 C 21.730227 590 0 615.380127 0 590 L 0 0 C 0 -25.380127 21.730227 0 48.53582 0 L 1000.464172 0 C 1027.269775 0 1049 -25.380127 1049 0 L 1049 196.308929 Z"/>
    <path id="Rettangolo" fill=%primary% fill-opacity="0.1" fill-rule="evenodd" stroke="none" d="M 0 590 L 1049 590 L 1049 0 L 0 0 Z"/>
</svg>

`,
    Background5: `<?xml version="1.0" encoding="UTF-8"?>
<!-- Generated by Pixelmator Pro 3.6.14 -->
<svg width="1049" height="590" viewBox="0 0 1049 590" xmlns="http://www.w3.org/2000/svg">
    <path id="Percorso" fill=%secondary% stroke="none" d="M 1049 388.704651 L 1049 590 C 1049 615.380127 1027.644897 590 1001.302063 590 L 611.972351 590 C 645.855774 517.846619 757.821838 440.336639 1049 388.704651 Z M 153.092972 0 C 200.132477 59.536743 400.704865 64.766479 611.392639 70.259827 C 761.808655 74.181824 917.380371 78.238129 1025.92041 102.286438 C 1033.970825 104.070099 1041.661987 106.223602 1049 108.711487 L 1049 45.954773 C 1049 20.574646 1075.342773 0 1049 0 L 153.092972 0 Z"/>
    <path id="Rettangolo" fill=%primary% fill-opacity="0.1" fill-rule="evenodd" stroke="none" d="M 0 590 L 1049 590 L 1049 0 L 0 0 Z"/>
</svg>


`,
    Background6: `<?xml version="1.0" encoding="UTF-8"?>
<!-- Generated by Pixelmator Pro 3.6.14 -->
<svg width="1049" height="590" viewBox="0 0 1049 590" xmlns="http://www.w3.org/2000/svg">
    <path id="Percorso" fill=%secondary% stroke="none" d="M 0 519.598816 C 93.173546 482.406433 332.318146 427.078217 504.146271 541.080383 C 534.153625 560.989258 566.305908 577.32959 599.484253 590 L 48.53582 590 C 21.730227 590 0 615.380127 0 590 L 0 519.598816 Z M 867.177612 0 L 1000.464172 0 C 1027.269775 0 1049 -25.380127 1049 0 L 1049 261.684723 C 1028.294067 223.019653 994.666138 200.058502 961.80365 177.620056 C 907.120178 140.282166 854.556274 104.39151 867.177612 0 Z M 1049 462.154755 L 1049 590 C 1049 615.380127 1027.269775 590 1000.464172 590 L 925.334229 590 C 980.53064 563.80957 1024.767334 521.467896 1049 462.154755 Z"/>
    <path id="Rettangolo" fill=%primary% fill-opacity="0.1" fill-rule="evenodd" stroke="none" d="M 0 590 L 1049 590 L 1049 0 L 0 0 Z"/>
</svg>
`,
    Background7: `<?xml version="1.0" encoding="UTF-8"?>
<!-- Generated by Pixelmator Pro 3.6.14 -->
<svg width="1049" height="590" viewBox="0 0 1049 590" xmlns="http://www.w3.org/2000/svg">
    <path id="Percorso" fill=%secondary% stroke="none" d="M 662.165405 0 C 674.972534 80.996002 707.918579 159.59906 776.562378 213.467346 C 915.046204 322.145111 1010.717773 475.13089 974.682861 590 L 999.897888 590 C 1027.016235 590 1049 615.380127 1049 590 L 1049 0 C 1049 -25.380127 1027.016235 0 999.897888 0 L 662.165405 0 Z"/>
    <path id="Rettangolo" fill=%primary% fill-opacity="0.1" fill-rule="evenodd" stroke="none" d="M 0 590 L 1049 590 L 1049 0 L 0 0 Z"/>
</svg>
`,
    Background8: `<?xml version="1.0" encoding="UTF-8"?>
<!-- Generated by Pixelmator Pro 3.6.14 -->
<svg width="1049" height="590" viewBox="0 0 1049 590" xmlns="http://www.w3.org/2000/svg">
    <path id="Percorso" fill=%secondary% stroke="none" d="M 196.979294 0 C 292.626129 70.311584 434.291595 127.498749 644.774109 63.743713 C 886.991577 -9.62384 894.14917 67.908875 901.778809 150.554993 C 905.865295 194.820282 910.087219 240.552429 950.63324 265.351746 C 1040.677856 320.425903 1005.194763 418.883789 971.568542 512.189453 C 961.931458 538.930298 952.446899 565.247986 946.113464 590 L 1001.353577 590 C 1027.667969 590 1049 615.380127 1049 590 L 1049 0 C 1049 -25.380127 1027.667969 0 1001.353577 0 L 196.979294 0 Z"/>
    <path id="Rettangolo" fill=%primary% fill-opacity="0.1" fill-rule="evenodd" stroke="none" d="M 0 590 L 1049 590 L 1049 0 L 0 0 Z"/>
</svg>
`,
    Background9: `<?xml version="1.0" encoding="UTF-8"?>
<!-- Generated by Pixelmator Pro 3.6.14 -->
<svg width="1049" height="590" viewBox="0 0 1049 590" xmlns="http://www.w3.org/2000/svg">
    <path id="Percorso" fill=%secondary% stroke="none" d="M -0 114.82016 C 93.173546 152.012573 332.318146 207.340759 504.146271 93.338562 C 694.874268 -33.203064 972.255615 -15.579468 1049 172.264221 L 1049 0 C 1049 -25.380127 1027.269775 0 1000.464172 0 L 48.53582 0 C 36.180733 0 3.252626 -1.245911 -0 0 C -1.216274 0.465881 -0 41.295471 -0 45.954773 Z M 865.8125 590 C 871.132385 518.709045 915.71521 488.267883 961.803711 456.798706 C 994.666138 434.360229 1028.294067 411.399109 1049 372.734131 L 1049 590 C 1049 615.380127 1027.269775 590 1000.464172 590 Z"/>
    <path id="Rettangolo" fill=%primary% fill-opacity="0.1" fill-rule="evenodd" stroke="none" d="M 0 590 L 1049 590 L 1049 0 L 0 0 Z"/>
</svg>
`
}

export const MacroBackgroundColors = {
    Green: {
        primary: "#29F29B",
        secondary: "#64E7AE"
    },
    Purple: {
        primary: "#EBAFFF",
        secondary: "#746DEA"
    },
    Pink: {
        primary: "#A8E8FF",
        secondary: "#FF9CFA"
    },
    Orange: {
        primary: "#FFC926",
        secondary: "#FFBD84"
    },
    Purple2: {
        primary: "#A8E8FF",
        secondary: "#C18EFF"
    },
    Salmon: {
        primary: "#FF6F6A",
        secondary: "#FFA397"
    },
    Yellow: {
        primary: "#FF92F0",
        secondary: "#FFE1A8"
    },
    Indacus: {
        primary: "#FFB753",
        secondary: "#8B9DFF"
    },
    Aqua: {
        primary: "#72FE80",
        secondary: "#7EE3FF"
    }

}

export const BlockType = {
    Section: "section",
    Text: "text",
    Markdown: "markdown",
    Image: "image",
    Video: "video",
    Column: "column",
    Row: "row",
    Button: "button",
    Editions: "editions",
    Collapsable: "collapsable",
    Carousel: "carousel",
    Slide: "slide",
    Icon: "icon",
    Faq: "faq",
    HTML: "html",
    Form: "form"
}


export const LessonState = {
    TooEarly: "too_early",
    Live: "live",
    Ended: "ended",
}

export const DailyAccessState = {
    Unknown: "unknown",
    None: "none",
    Lobby: "lobby",
    Full: "full"
}

export const FeedbackType = {
    Course: "course",
    Lesson: "lesson",
    Edition: "edition"
}

export const FeedbackQuestionType = {
    Open: "open",
    Quantitative: "quantitative",
    Qualitative: "qualitative",
}

export const InstallmentType = {
    Internal: "internal",
    External: "external"
}

export const CourseCategories = [
    { id: 0, name: 'Professionalizzanti', value: 'professional' },
    { id: 1, name: 'Educazione Finanziaria', value: 'edufin' },
    { id: 2, name: 'Esperienze', value: 'bootcamp' },
    { id: 3, name: 'Webinar', value: 'webinar' },
    { id: 4, name: 'Corporate Academy', value: 'corporate' },
]

export const CourseTypes = [
    { id: 0, name: 'Masterclass', value: CourseType.Masterclass },
    { id: 1, name: 'Master', value: CourseType.Professional },
    { id: 2, name: 'Bootcamp', value: CourseType.Bootcamp },
    { id: 3, name: 'Webinar', value: CourseType.Webinar },
    { id: 4, name: 'Pack', value: CourseType.Pack },
]

export const CourseStatuses = [
    { id: 0, name: 'Pubblico', value: 'public' },
    { id: 1, name: 'Bozza', value: 'draft' },
    { id: 2, name: 'Nascosto', value: 'hidden' },
]
